import {Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ReportsService} from "../reports.service";
import {CurrentRouteService} from "../../currentRoute.service";
import {AccountIdService, AgencyIdService} from "../../account.service";
import {UntypedFormBuilder, FormGroup, Validators} from "@angular/forms";

import * as _moment from 'moment';
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";
import {CampaignIdInterfaceData} from "../../shared/models/adwords.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatAccordion} from "@angular/material/expansion";
import {PageEvent} from "@angular/material/paginator";

export interface UserData {
  id: string;
  name: string;
  progress: string;
  fruit: string;
}

/** Constants used to fill up our data base. */
const FRUITS: string[] = [
  'blueberry',
  'lychee',
  'kiwi',
  'mango',
  'peach',
  'lime',
  'pomegranate',
  'pineapple',
];
const NAMES: string[] = [
  'Maia',
  'Asher',
  'Olivia',
  'Atticus',
  'Amelia',
  'Jack',
  'Charlotte',
  'Theodore',
  'Isla',
  'Oliver',
  'Isabella',
  'Jasper',
  'Cora',
  'Levi',
  'Violet',
  'Arthur',
  'Mia',
  'Thomas',
  'Elizabeth',
];

@Component({
  selector: 'app-report-actions-paging',
  templateUrl: './report-actions-paging.component.html',
  styleUrls: ['./report-actions-paging.component.css']
})
export class ReportActionsPagingComponent implements OnInit {

  account_id: string;
  start_date: string;
  end_date: string;
  offset: number;
  is_loading: boolean = false;
  resultsLength = 0;
  limit: number = 30;

  displayedColumns: string[] = ['id', 'name', 'progress', 'fruit'];
  dataSource: MatTableDataSource<UserData>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  bugger = []

  constructor(
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private reportService: ReportsService,
  ) {
    const users = Array.from({length: 100}, (_, k) => createNewUser(k + 1));
    this.bugger = users;
    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource(users);
  }

  ngOnInit(): void {

    this.route.params.subscribe(parms => {
      this.account_id = parms['account_id'];
      this.start_date = '2022-08-01';
      this.end_date = '2022-08-15';
      let offset = 0;
      this.loadDataCount()
      //this.loadData(this.limit,offset)

    });


  } //end ngOnInit

  loadDataCount(){

    this.is_loading = true;
    let endpoint = `reports?rt=actions&account_id=${this.account_id}&start_date=${this.start_date}&end_date=${this.end_date}&count=true`;
    let fu = this.reportService.get(endpoint).subscribe(x => {
      if (_.isEmpty(x['body'])) {

      } else {

       console.log('resultsLength',x['body'])
        this.resultsLength = x['body'][0]['count']
        let offset = 0;
        this.loadData(this.limit,offset)
      } //end if else

    }) //end fu

  }



  loadDataPaging(start, end, page, limit) {

    // this.is_journey_data_loaded = false;
    // this.journey_list = [];
    this.is_loading = true;
    let endpoint = `reports?rt=actions&account_id=${this.account_id}&start_date=${this.start_date}&end_date=${this.end_date}&action_id=call&offset=${this.offset}&limit=${this.limit}`;
    // let fu = this.reportService.get(endpoint).subscribe(x => {
    //   if (_.isEmpty(x['body'])) {
    //     this.is_journey_data_loaded = true;
    //     this.is_loading = false;
    //   } else {
    //     let keys = Object.keys(x['body'])
    //     for (var _i = 0; _i < keys.length; _i++) {
    //       this.journey_list.push(x['body'][_i])
    //     } //end for
    //   } //end if else
    //
    //
    //   this.dataSourceJourney = new MatTableDataSource(this.journey_list);
    //   this.cdr.detectChanges();
    //   this.dataSourceJourney.paginator = this.paginator.toArray()[2];
    //   this.dataSourceJourney.sort = this.sort.toArray()[2];
    //   this.is_journey_data_loaded = true;
    //   this.is_loading = false;
    // }) //end fu

  } //end LoadDataAuid

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    //this.resultsLength = this.bugger.length;

    console.log('wtf',this.paginator.page,this.paginator.pageIndex)
    console.log('booya')
  }

  is_data_loaded: boolean = false;
  is_data: boolean = false;
  call_list = [];
  form_list = [];
  clickfunnels_list = [];

  loadData(limit,offset) {



    this.is_loading = true;

    let endpoint = `reports?rt=actions&account_id=${this.account_id}&start_date=${this.start_date}&end_date=${this.end_date}&action_id=call&offset=${offset}&limit=${limit}`;
    let fu = this.reportService.get(endpoint).subscribe(x => {

      console.log(x['body'])
      this.is_data_loaded = false;
      if (_.isEmpty(x['body'])) {
        this.is_data = true;
        this.is_loading = false;
      } else {
        let keys = Object.keys(x['body'])
        for (var _i = 0; _i < keys.length; _i++) {
          console.log(x['body'][_i]['provider'])
          if (x['body'][_i]['provider'] == 'calendy') {
            this.call_list.push(x['body'][_i])
          }
          if (x['body'][_i]['provider'] == 'email') {
            let ff = x['body'][_i];
            ff['emailAddress'] = ff['invitee_email'];
            ff['fullname'] = ff['invitee_full_name']
            if (ff['invitee_email']) {
              this.call_list.push(ff)
            }
          }
          if (x['body'][_i]['provider'] == 'form') {
            this.form_list.push(x['body'][_i])
            this.call_list.push(x['body'][_i])
          }
          // if (x['body'][_i]['provider'] == 'clickfunnels') {
          //   this.clickfunnels_list.push(x['body'][_i])
          // }
        } //end loop

        // this.dataSource = new MatTableDataSource(this.call_list);
        // this.cdr.detectChanges();
        // this.dataSourceClickfunnel = new MatTableDataSource(this.clickfunnels_list);
        // this.cdr.detectChanges();
        // //https://stackoverflow.com/questions/50428605/multiple-material-pagination-in-one-component-doesnt-work-in-angular
        // this.dataSource.paginator = this.paginator.toArray()[0];
        // this.dataSource.sort = this.sort.toArray()[0];
        // this.dataSourceClickfunnel.paginator = this.paginator.toArray()[1];
        // this.dataSourceClickfunnel.sort = this.sort.toArray()[1];

        console.log(this.call_list)

        this.is_data_loaded = true;
        this.is_loading = false;
      }


    }, error => {
      //console.log('ERROR@@@@@@@@@@@@@@@@@@@@ ',error)
      this.is_loading = false;
      this.is_data = true;
    }); //end apiService


  } //end LoadData

  ngOnChanges(){
    console.log('wtf',this.paginator.page,this.paginator.pageIndex)
  }

  public  getPaginatorData(event: PageEvent): PageEvent {
    console.log('booya', event)
    console.log('event.pageIndex:', event.pageIndex)
    console.log('event.pageSize:', event.pageSize)
    console.log('event.length:',event.length)
    console.log('event.previousPageIndex:',event.previousPageIndex)
    //this.lowValue = event.pageIndex * event.pageSize;
    //this.highValue = this.lowValue + event.pageSize;







    return event;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // ngAfterViewInit() {
  //   this.loadDataPaging(this.start_date, this.end_date, this.offset, this.limit);
  // } //end ngAfterViewInit


} //end class


/** Builds and returns a new User. */
function createNewUser(id: number): UserData {

  const name =
    NAMES[Math.round(Math.random() * (NAMES.length - 1))] +
    ' ' +
    NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) +
    '.';

  return {
    id: id.toString(),
    name: name,
    progress: Math.round(Math.random() * 100).toString(),
    fruit: FRUITS[Math.round(Math.random() * (FRUITS.length - 1))],
  };
}
